export * from './ps-manutencao.component';
